import parse from "html-react-parser";

export const convertIconToReactNode = (icon: string) => {
  if (icon === undefined || icon === null) return;

  return parse(icon);
};
